import General from '../components/general';
import Header from '../components/header';

export default {
	init() {
		Header.init();
		General.init();
	},
	finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js